import type { WidgetType } from '@logspot-platform/widgets';

export type EmbedWidgetConfig = {
  type: WidgetType;
  params?: {
    title?: string;
    eventName?: string;
    property?: string;
    /**
     * Name of a host-page function (provided via the loader's `mapping`
     * option) used to map raw property values before display.
     */
    mapFunction?: string;
  };
};

// Mirrors the legacy embed's default widget set
// (logspot-embed/src/components/widgets/default-widgets.js).
export const DEFAULT_WIDGETS: EmbedWidgetConfig[] = [
  {
    type: 'DAU',
  },
  {
    type: 'EVENT',
    params: {
      title: 'Pageview',
      eventName: 'Pageview',
    },
  },
  {
    type: 'AGGREGATION_BY_PROPERTY',
    params: {
      title: 'Top pages',
      eventName: 'Pageview',
      property: '_url',
    },
  },
  {
    type: 'REFERRER',
    params: {
      title: 'Top sources',
    },
  },
  {
    type: 'COUNTRY',
    params: {
      title: 'Country',
    },
  },
  {
    type: 'AGGREGATION_BY_PROPERTY',
    params: {
      title: 'City',
      property: '_location_city',
      eventName: 'Pageview',
    },
  },
  {
    type: 'AGGREGATION_BY_PROPERTY',
    params: {
      title: 'Screen',
      property: '_screen',
      eventName: 'Pageview',
    },
  },
  {
    type: 'AGGREGATION_BY_PROPERTY',
    params: {
      title: 'Device',
      property: '_device',
      eventName: 'Pageview',
    },
  },
  {
    type: 'AGGREGATION_BY_PROPERTY',
    params: {
      title: 'Browser',
      property: '_browser',
      eventName: 'Pageview',
    },
  },
  {
    type: 'AGGREGATION_BY_PROPERTY',
    params: {
      title: 'OS',
      property: '_os',
      eventName: 'Pageview',
    },
  },
  {
    type: 'CAMPAIGNS',
    params: {
      title: 'Campaigns',
    },
  },
];
